import { useSyncExternalStore } from 'react';
import { useTranslation as useI18nTranslation } from 'react-i18next';
import i18n from '@/i18n/config';
import type { Namespace } from '../i18n/types';

export function useTranslation(ns?: Namespace) {
  return useI18nTranslation(ns);
}

export function useI18nLocale(): string {
  return useSyncExternalStore(
    (onStoreChange) => {
      const handler = () => {
        onStoreChange();
      };
      i18n.on('languageChanged', handler);
      return () => {
        i18n.off('languageChanged', handler);
      };
    },
    () => i18n.resolvedLanguage ?? i18n.language,
    () => 'en',
  );
}
